(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.instantCheckoutBound) {
    window.instantCheckoutBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-instant-checkout]');
      if (!button || button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

      const form = button.closest('form');
      const productForm = button.closest('product-form');
      if (!form || !window.routes?.cart_add_url) return;

      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      button.querySelector('.loading__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = new FormData(form);

      const resetButton = () => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        button.querySelector('.loading__spinner')?.classList.add('hidden');
      };

      fetch(window.routes.cart_add_url, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            productForm?.handleErrorMessage(response.description);
            resetButton();
            return;
          }

          window.location.href = button.dataset.checkoutUrl || '/checkout';
        })
        .catch((error) => {
          console.error(error);
          resetButton();
        });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
